import React, { Component } from 'react';
import { Form, Input, Button } from 'antd';
import { graphql, compose } from 'react-apollo';
import { SuccessReportFormCard } from "./successReportCard";
import { ROLE_TO_REPORT_TYPE_MAPPING} from "./constants";

import Spinner from '../../spinner/spinner';

import PropTypes from 'prop-types';
import { getCurrentUserSuccessReports } from './queries/getCurrentUserSuccessReports';
import { submitSuccessReport } from "./mutations/submitSuccessReport";

const FormItem = Form.Item;
const { TextArea } = Input;

class SuccessReportForm extends Component {
  static propTypes = {
    mutate: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {loading: false};
  }

  get mutationParams() {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue(),
          church_revival_id: this.props.data.church.revival.id
        }
      },
      update: (proxy, { data: { submitSuccessReport } }) => {
        const data = proxy.readQuery(
          { query: getCurrentUserSuccessReports, variables: { id: this.props.selectedChurch.id } }
        );
        const newNode = { node: submitSuccessReport.successReport, __typename: "SuccessReportEdge" };
        const index = data.church.revival.successReports.edges.findIndex((edge) => {
          return edge.node.author.type === data.current_user.type;
        });

        if (index === -1) {
          data.church.revival.successReports.edges.push(newNode);
        } else {
          data.church.revival.successReports.edges[index] = newNode;
        }
        proxy.writeQuery({ query: getCurrentUserSuccessReports, data });
      }
    }
  }

  get successReport() {
    const currentUser = this.props.data.current_user;
    const successReports = this.props.data.church.revival.successReports.edges.map(edge => edge.node);
    if (successReports.length < 1) {
      return {};
    }
    const successReport = successReports.find((report) => report.type === ROLE_TO_REPORT_TYPE_MAPPING[currentUser.type]);
    if (successReport) {
      return successReport;
    } else {
      return {};
    }
  }

  async submitData() {
    this.setState({loading: true});
    const {data} = await this.props.mutate(this.mutationParams);
    this.redirectToList();
  }

  onSubmit = (event) => {
    event.preventDefault();

    this.props.form.validateFields((error, _values) => {
      if (!error) {
        this.submitData();
      }
    });
  };

  redirectToList = () => {
    this.props.history.push(`/dashboard/${this.props.data.church.id}/successReports`);
  };

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    }
    const { getFieldDecorator } = this.props.form;

    return (
      <SuccessReportFormCard photo={this.props.data.current_user.photo.small}>
        <Form onSubmit={this.onSubmit}>
          <FormItem>
            {getFieldDecorator('title', {
              initialValue: this.successReport.title,
              rules: [
                { required: true, message: 'Please enter Event Report headline' }
              ],
            })(
              <Input placeholder="Event Report headline"/>
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('text', {
              initialValue: this.successReport.text,
              rules: [
                { required: true, message: 'Please enter Event Report text' }
              ],
            })(
              <TextArea rows={10} placeholder="Event Report text"/>
            )}
          </FormItem>
          <div className="align-right">
            <Button onClick={this.redirectToList}>
              CANCEL
            </Button>
            <Button type="primary" htmlType="submit" className="profile-form__submit-button" loading={this.state.loading}>
              SAVE
            </Button>
          </div>
        </Form>
      </SuccessReportFormCard>
    )
  }
}

export default Form.create()(compose(
  graphql(getCurrentUserSuccessReports, {
    options: ({ selectedChurch }) => ({ variables: { id: selectedChurch.id } })
  }),
  graphql(submitSuccessReport),
)(SuccessReportForm));



// WEBPACK FOOTER //
// ./src/components/pages/successReports/form.js